module.exports = __webpack_public_path__ + "static/fayoke-b93f687ce09c70098402ab6ef7b879da.jpg";